export class TransformField {
  constructor(
    public target: string,
    public source: string,
    public type: string,
    public display = true,
    public changed = false,
    public description = '',
    public source_alias = '',
    public applied = false,
    public sourceTypeChanged = false,
  ) {}
}
